import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import SubAdminDetails from '../SubAdmins/SubAdminDetails/SubAdminDetails'
import {UsersListWrapper} from './users-list/UsersList'
import UsersDetailsPage from './UsersDetailsPage'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Bookings Management',
    path: '/apps/bookings',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const BookingsManagement = () => {
  return (
    <Routes>
      {/* <Route element={<Outlet />}> */}
      <Route
        path='/:p'
        element={
          <>
            <PageTitle breadcrumbs={usersBreadcrumbs}>Bookings list</PageTitle>
            <UsersListWrapper />
          </>
        }
      />
      <Route path='bookings/details-page' element={<UsersDetailsPage />} />

      {/* </Route> */}
      <Route element={<Navigate to='/apps/bookings' />} />
    </Routes>
  )
}

export default BookingsManagement
